import React, { useEffect, useState } from "react";
import Col from "react-bootstrap/Col";
import Modal from "react-bootstrap/Modal";
import Row from "react-bootstrap/Row";

// Components
import { InputField } from "../../../../Components/formElements/InputField";
import toast from "react-hot-toast";

//Serivce
import ItemService from "../../../../services/customer_appCommonService";
import { TextAreaField } from "../../../../Components/formElements/TextAreaField";
import { useDispatch, useSelector } from "react-redux";
import { getMaterialList } from "../../../../redux/feature/customer_app/customerV1Slice";
import ShowUploadImage from "./ShowUploadImage";
import { validateRequired } from "../../../../common/Validations";
import { ComboboxField } from "../../../../Components/formElements/ComboboxField";
import { MultiselectField } from "../../../../Components/formElements/MultiselectField";
import FileViewerModalForHB from "../../../smart_construction_app/Customer_V4/Common/FileViewerModalForHB";
import FileUploadComponentForHB from "../Common/FileUploadComponentForHB";

const MaterialHBModal = React.forwardRef((props, ref) => {
  const message = {
    VALID_CUSTOMER_NAME: "Special characters or numbers are not allowed.",
    VALID_MAIL_ID: "Please enter a valid email address.",
    VALID_ALTERNATE_MAIL_ID: "Please enter a valid alternate email address.",
    VALID_CONTACT_NUMBER: "Please enter a valid contact number.",
    VALID_ALTERNATE_CONTACT_NUMBER:
      "Please enter a valid alternate contact number.",
    VALID_PURPOSE_JUSTIFICATION:
      "Please ensure the justification is under 500 characters.",
    VALID_POSTAL_CODE:
      "Enter a 6-character postal code with uppercase letters and numbers only",
    VALID_CONTACT_FIRST_NAME: "Special characters and numbers are not allowed",
    VALID_CONTACT_LAST_NAME: "Special characters and numbers are not allowed",
    EXIStS_MAIL_ID: "Email already exists",
    EXIStS_CONTACT_NUMBER: "Contact Number already exists",
    EXIStS_ALTERNATE_CONTACT_NUMBER: "Contact Number already exists",
    EXIStS_ALTERNATE_MAIL_ID: "Alternate Contact Number already exists",
    FILL_REQUIRED_FIELD: "Please fill the required field",
    ALTERNATE_MAIL_ID: "Email ID is same",
    ALTERNATE_CONTACT_NUMBER: "Contact number is same",
  };

  let materialNr = useSelector(
    (state) => state?.customerV1?.material?.materialNr,
  );

  const dispatch = useDispatch();

  const [formInputs, setFormInputs] = useState({
    materialAttachments: "",
    materialImage: "",
    buildingType: [],
  });
  const failureModalData = {
    title: "Warning",
    ErrorMsg: "",
  };

  const materialGroups = [
    {
      id: 1,
      name: "BUILTUP WEB PLATE",
      code: "BWP",
      description: "BUILTUP WEB PLATE",
    },
    {
      id: 2,
      name: "BUILTUP FLANGE PLATE",
      code: "BFP",
      description: "BUILTUP FLANGE PLATE",
    },
    {
      id: 3,
      name: "HB",
      code: "HB",
      description: "hallyesBlue",
    },
    {
      id: 4,
      name: "APSHSX",
      code: "APSHSX",
      description: "Apollo Square Hollow Section",
    },
    {
      id: 5,
      name: "Others",
      code: "OTHERS",
      description: "Others",
    },
  ];

  const buildingTypes = [
    { id: 1, name: "CS", code: "CS", discription: "CS" },
    { id: 2, name: "MS", code: "MS", discription: "MS" },
    { id: 3, name: "MG", code: "MG", discription: "MG" },
  ];

  const [validation, setValidation] = useState({});
  const [getErrorFields, setErrorFields] = useState([]);
  const [getShowFailureModal, setShowFailureModal] = useState();

  const [disabled, setDisabled] = useState("");

  const [getShowFileViewModal, setShowFileViewModal] = useState(false);
  const [getFileViewData, setFileViewData] = useState(null);

  const [isCardVisible1, setCardVisible1] = useState(true);

  const [materialMode, setMaterialMode] = useState(true);

  const [loading, setLoading] = useState(false);

  const [webplate, setWebPlate] = useState({});

  const [getDropdownData, setDropdownData] = useState("");

  useEffect(() => {
    if (props?.show === "CREATE") {
      setFormInputs({
        materialAttachments: "",
        materialImage: "",
        materialCode: "",
        materialDescription: "",
        materialGroup: "",
        average: "",
        quntity: "",
        pieceMeasure: "",
        unit: "",
        unitWeight: "",
        unitPrice: "",
        unitWeightModifier: "",
        unitPriceModifier: "",
        surfacePaintArea: "",
        remarks: "",
        weightPice: "",
        weightTotal: "",
        bookPrice: "",
        bookTotalPrice: "",
        materialCategory: "",
        materialCategoryCode: "",
        materialCategoryDesc: "",
        materialSubCategory: "",
        materialSubCategoryCode: "",
        materialSubCategoryDesc: "",
        materialGroupCode: "",
        materialGroupDesc: "",
        buildingType: [],
      });
      setWebPlate({});
      setMaterialMode(false);
    } else if (props?.show === "EDIT") {
      setMaterialMode(false);
    } else if (props?.show === "DETAILS") {
      setMaterialMode(true);
    } else {
      setMaterialMode(true);
    }
  }, [props?.show]);

  const toggleCardVisibility1 = () => {
    setCardVisible1(!isCardVisible1);
  };

  const hideFailureModal = () => {
    setShowFailureModal(false);
  };
  // eslint-disable-next-line
    const [fileDeleted, setFileDeleted] = useState(false);
    
  const handleAttachmentDeleted = ({ attachmentId, hasFiles, remainingCount }) => {
    // console.log("handleAttachmentDeleted called:", { attachmentId, hasFiles, remainingCount });
    
    //  If NO files remain, clear the supportingDoc field
    if (!hasFiles) {
      console.log("No files remaining, clearing supportingDoc");
      setFormInputs((prev) => ({
        ...prev,
        supportingDoc: "",  // ← Clear the attachment ID
      }));
      setFileDeleted(true); 
    } else {
      //  If files still exist, update with new count (optional)
      console.log("Files still exist, count:", remainingCount);
    }
  };

  useEffect(() => {
    if (props?.show === "CREATE") {
      setFormInputs({
        materialAttachments: "",
        materialImage: "",
        materialCode: "",
        materialDescription: "",
        materialGroup: "",
        average: "",
        quntity: "",
        pieceMeasure: "",
        unit: "",
        unitWeight: "",
        unitPrice: "",
        unitWeightModifier: "",
        unitPriceModifier: "",
        surfacePaintArea: "",
        remarks: "",
        weightPice: "",
        weightTotal: "",
        bookPrice: "",
        bookTotalPrice: "",
        materialCategory: "",
        materialCategoryCode: "",
        materialCategoryDesc: "",
        materialSubCategory: "",
        materialSubCategoryCode: "",
        materialSubCategoryDesc: "",
        materialGroupCode: "",
        materialGroupDesc: "",
      });
    }
  }, [props?.show]);

  useEffect(() => {
    const handleEscapeKey = (event) => {
      if (event.key === "Escape" || event.keyCode === 27) {
        props.onHide();
      }
    };
    document.addEventListener("keydown", handleEscapeKey);
    return () => {
      document.removeEventListener("keydown", handleEscapeKey);
    };
  }, [props]);

  const onInputChange = ({ target: { name, value } }) => {
    const errors = {};
    setFormInputs((prev) => {
      const formattedValue =
        name === "materialCode" || name === "materialDescription"
          ? value.toUpperCase()
          : value;

      const updated = { ...prev, [name]: formattedValue };

      // Parse values to numbers (default to 0 if empty/invalid)
      const pieceMeasure = parseFloat(updated.pieceMeasure) || 0;
      const unitWeight = parseFloat(updated.unitWeight) || 0;
      const unitWeightModifier = parseFloat(updated.unitWeightModifier) || 0;
      const unitPrice = parseFloat(updated.unitPrice) || 0;
      const unitPriceModifier = parseFloat(updated.unitPriceModifier) || 0;
      const quantity = parseFloat(updated.quntity) || 0;

      // Helper for rounding to 3 decimals
      const round3 = (num) => Math.round(num * 1000) / 1000;

      // Calculations (rounded)
      const weightPice = round3(pieceMeasure * unitWeight * unitWeightModifier);
      const weightTotal = round3(weightPice * quantity);
      const bookPrice = round3(pieceMeasure * unitPrice * unitPriceModifier);
      const bookTotalPrice = round3(bookPrice * quantity);

      return {
        ...updated,
        weightPice,
        weightTotal,
        bookPrice,
        bookTotalPrice,
      };
    });

    setValidation((prev) => ({
      ...prev,
      [name]: errors[name] || "",
    }));
  };

 

  useEffect(() => {
    if ((props?.show === "EDIT" || props?.show === "DETAILS") && materialNr) {
      setLoading(true);
      let obj = {
        queryName: "Get_MATERIAL_DETAIL",
        documentNumber: materialNr,
      };
      ItemService.generateCustomerQueryHb(obj)
        .then((res) => {
          if (res?.data?.length) {
            const data = res.data[0];
            setFormInputs(data);

            // ✅ Populate webplate from API data so ComboboxField setValue works
            setWebPlate({
              materialGroup: data?.materialGroup || "",
              materialGroupCode: data?.materialGroupCode || "",
              materialGroupDesc: data?.materialGroupDesc || "",
              materialCategory: data?.materialCategory || "",
              materialCategoryCode: data?.materialCategoryCode || "",
              materialCategoryDesc: data?.materialCategoryDesc || "",
              materialSubCategory: data?.materialSubCategory || "",
              materialSubCategoryCode: data?.materialSubCategoryCode || "",
              materialSubCategoryDesc: data?.materialSubCategoryDesc || "",
            });
          }
        })
        .catch(() => {
          toast.error("Failed to fetch material details!");
        })
        .finally(() => {
          setLoading(false);
        });
    }
  }, [props?.show, materialNr]);

  const handleSubmit = async () => {
    let requiredFields = [];
    const anyFieldNotEmpty = Object.values(validation).some(
      (value) => value !== null && value !== "",
    );
    if (anyFieldNotEmpty) {
      requiredFields.push(`${message.FILL_REQUIRED_FIELD}`);
      setErrorFields(requiredFields);
      setShowFailureModal(true);
      return;
    }

    if (!validateRequired(formInputs.materialCode)) {
      requiredFields.push(`${message.FILL_REQUIRED_FIELD}`);
      setValidation((prev) => ({
        ...prev,
        materialCode: message.FILL_REQUIRED_FIELD,
      }));
      return;
    }
    //-------------------------------------------

    // if (!validateRequired(formInputs.materialDescription)) {
    //   requiredFields.push(`${message.FILL_REQUIRED_FIELD}`);
    //   setValidation((prev) => ({
    //     ...prev,
    //     materialDescription: message.FILL_REQUIRED_FIELD,
    //   }));
    //   return;
    // }

    // if (!validateRequired(formInputs.materialDescription)) {
    //   requiredFields.push(`${message.FILL_REQUIRED_FIELD}`);
    //   setValidation((prev) => ({
    //     ...prev,
    //     materialDescription: message.FILL_REQUIRED_FIELD,
    //   }));
    //   return;
    // }
    //-------------------
    // if (!validateRequired(formInputs.materialGroup)) {
    //   requiredFields.push(`${message.FILL_REQUIRED_FIELD}`);
    //   setValidation((prev) => ({
    //     ...prev,
    //     materialGroup: message.FILL_REQUIRED_FIELD,
    //   }));
    //   return;
    // }
    if (!validateRequired(formInputs.unit)) {
      requiredFields.push(`${message.FILL_REQUIRED_FIELD}`);
      setValidation((prev) => ({
        ...prev,
        unit: message.FILL_REQUIRED_FIELD,
      }));
      return;
    }
    if (!validateRequired(formInputs.unitWeight)) {
      requiredFields.push(`${message.FILL_REQUIRED_FIELD}`);
      setValidation((prev) => ({
        ...prev,
        unitWeight: message.FILL_REQUIRED_FIELD,
      }));
      return;
    }
    if (!validateRequired(formInputs.unitPrice)) {
      requiredFields.push(`${message.FILL_REQUIRED_FIELD}`);
      setValidation((prev) => ({
        ...prev,
        unitPrice: message.FILL_REQUIRED_FIELD,
      }));
      return;
    }
    // if (!validateRequired(formInputs.unitWeightModifier)) {
    //   requiredFields.push(`${message.FILL_REQUIRED_FIELD}`);
    //   setValidation((prev) => ({
    //     ...prev,
    //     unitWeightModifier: message.FILL_REQUIRED_FIELD,
    //   }));
    //   return;
    // }
    // if (!validateRequired(formInputs.unitPriceModifier)) {
    //   requiredFields.push(`${message.FILL_REQUIRED_FIELD}`);
    //   setValidation((prev) => ({
    //     ...prev,
    //     unitPriceModifier: message.FILL_REQUIRED_FIELD,
    //   }));
    //   return;
    // }
    // if (!validateRequired(formInputs.surfacePaintArea)) {
    //   requiredFields.push(`${message.FILL_REQUIRED_FIELD}`);
    //   setValidation((prev) => ({
    //     ...prev,
    //     surfacePaintArea: message.FILL_REQUIRED_FIELD,
    //   }));
    //   return;
    // }
    if (!validateRequired(formInputs.remarks)) {
      requiredFields.push(`${message.FILL_REQUIRED_FIELD}`);
      setValidation((prev) => ({
        ...prev,
        remarks: message.FILL_REQUIRED_FIELD,
      }));
      return;
    }

    let thickNessInMeter = parseFloat(formInputs?.thickNess) / 1000 || 0;
    let webPlateXInMeter = parseFloat(formInputs?.webPlateX) / 1000 || 0;
    let webPlateYInMeter = parseFloat(formInputs?.webPlateY) / 1000 || 0;
    let avg = parseFloat(webPlateXInMeter + webPlateYInMeter) / 2 || 0;

    const isGroupOthers = webplate?.materialGroupCode === "OTHERS";
    const isCategoryOthers = webplate?.materialCategoryCode === "OTHERS";
    const isSubCategoryOthers = webplate?.materialSubCategoryCode === "OTHERS";


    let obj = {
      data: {
        ...formInputs,
        thickNessInMeter,
        webPlateXInMeter,
        webPlateYInMeter,
        avg,
        buildingType: formInputs?.buildingType || [],

        materialGroup: isGroupOthers
          ? formInputs?.materialGroup || ""
          : webplate?.materialGroup || "",
        materialGroupCode: isGroupOthers
          ? formInputs?.materialGroupCode || ""
          : webplate?.materialGroupCode || "",
        materialGroupDesc: isGroupOthers
          ? formInputs?.materialGroupDesc || ""
          : webplate?.materialGroupDesc || "",

        materialCategory: isCategoryOthers
          ? formInputs?.materialCategory || ""
          : webplate?.materialCategory || "",
        materialCategoryCode: isCategoryOthers
          ? formInputs?.materialCategoryCode || ""
          : webplate?.materialCategoryCode || "",
        materialCategoryDesc: isCategoryOthers
          ? formInputs?.materialCategoryDesc || ""
          : webplate?.materialCategoryDesc || "",

        materialSubCategory: isSubCategoryOthers
          ? formInputs?.materialSubCategory || ""
          : webplate?.materialSubCategory || "",
        materialSubCategoryCode: isSubCategoryOthers
          ? formInputs?.materialSubCategoryCode || ""
          : webplate?.materialSubCategoryCode || "",
        materialSubCategoryDesc: isSubCategoryOthers
          ? formInputs?.materialSubCategoryDesc || ""
          : webplate?.materialSubCategoryDesc || "",
      },
    };

    setDisabled(true);
    setDisabled(true);
    await ItemService.addMaterialHb(obj).then((item) => {
      if (item?.status === 200) {
        toast.success(item?.message || "User Invited successfully", {
          duration: 2000,
          position: "top-right",
        });
        props.onHide();

        setFormInputs({
          materialAttachments: "",
          materialImage: "",
          materialCode: "",
          materialDescription: "",
          materialGroup: "",
          average: "",
          quntity: "",
          pieceMeasure: "",
          unit: "",
          unitWeight: "",
          unitPrice: "",
          unitWeightModifier: "",
          unitPriceModifier: "",
          surfacePaintArea: "",
          remarks: "",
          weightPice: "",
          weightTotal: "",
          bookPrice: "",
          bookTotalPrice: "",
          materialCategory: "",
          materialCategoryCode: "",
          materialCategoryDesc: "",
          materialSubCategory: "",
          materialSubCategoryCode: "",
          materialSubCategoryDesc: "",
          materialGroupCode: "",
          materialGroupDesc: "",
        });
        let obj = {
          queryName: "Get_MATERIAL_LIST",
          page: 1,
          per_page: 10,
        };
        dispatch(getMaterialList(obj));
      } else {
        toast.error(item?.message || "Please try again !!", {
          duration: 4000,
          position: "top-right",
        });
        // setErrorMsg("*" + item?.message);
      }
      setDisabled(false);
    });
    toast.dismiss("");
  };


  const handleUpdate = async () => {
    let thickNessInMeter = parseFloat(formInputs?.thickNess) / 1000 || 0;
    let webPlateXInMeter = parseFloat(formInputs?.webPlateX) / 1000 || 0;
    let webPlateYInMeter = parseFloat(formInputs?.webPlateY) / 1000 || 0;
    let avg = parseFloat(webPlateXInMeter + webPlateYInMeter) / 2 || 0;

    // ✅ Same OTHERS checks as handleSubmit
    const isGroupOthers = webplate?.materialGroupCode === "OTHERS";
    const isCategoryOthers = webplate?.materialCategoryCode === "OTHERS";
    const isSubCategoryOthers = webplate?.materialSubCategoryCode === "OTHERS";

    let obj = {
      ...formInputs,
      thickNessInMeter,
      webPlateXInMeter,
      webPlateYInMeter,
      avg,

      // ✅ buildingType array
      buildingType: formInputs?.buildingType || [],

      // ✅ materialGroup
      materialGroup: isGroupOthers
        ? formInputs?.materialGroup || ""
        : webplate?.materialGroup || "",
      materialGroupCode: isGroupOthers
        ? formInputs?.materialGroupCode || ""
        : webplate?.materialGroupCode || "",
      materialGroupDesc: isGroupOthers
        ? formInputs?.materialGroupDesc || ""
        : webplate?.materialGroupDesc || "",

      // ✅ materialCategory
      materialCategory: isCategoryOthers
        ? formInputs?.materialCategory || ""
        : webplate?.materialCategory || "",
      materialCategoryCode: isCategoryOthers
        ? formInputs?.materialCategoryCode || ""
        : webplate?.materialCategoryCode || "",
      materialCategoryDesc: isCategoryOthers
        ? formInputs?.materialCategoryDesc || ""
        : webplate?.materialCategoryDesc || "",

      // ✅ materialSubCategory
      materialSubCategory: isSubCategoryOthers
        ? formInputs?.materialSubCategory || ""
        : webplate?.materialSubCategory || "",
      materialSubCategoryCode: isSubCategoryOthers
        ? formInputs?.materialSubCategoryCode || ""
        : webplate?.materialSubCategoryCode || "",
      materialSubCategoryDesc: isSubCategoryOthers
        ? formInputs?.materialSubCategoryDesc || ""
        : webplate?.materialSubCategoryDesc || "",
    };

    setDisabled(true);
    await ItemService.updateMaterialHb(obj).then((item) => {
      if (item?.status === 200) {
        toast.success(item?.message || "Updated successfully", {
          duration: 2000,
          position: "top-right",
        });
        props.onHide();

        setFormInputs({
          materialAttachments: "",
          materialImage: "",
          materialCode: "",
          materialDescription: "",
          materialGroup: "",
          average: "",
          quntity: "",
          pieceMeasure: "",
          unit: "",
          unitWeight: "",
          unitPrice: "",
          unitWeightModifier: "",
          unitPriceModifier: "",
          surfacePaintArea: "",
          remarks: "",
          weightPice: "",
          weightTotal: "",
          bookPrice: "",
          bookTotalPrice: "",
          materialCategory: "",
          materialCategoryCode: "",
          materialCategoryDesc: "",
          materialSubCategory: "",
          materialSubCategoryCode: "",
          materialSubCategoryDesc: "",
          materialGroupCode: "",
          materialGroupDesc: "",
          buildingType: [], // ✅ reset buildingType too
        });

        // ✅ reset webplate too
        setWebPlate({});

        let obj = {
          queryName: "Get_MATERIAL_LIST",
          page: 1,
          per_page: 10,
        };
        dispatch(getMaterialList(obj));
      } else {
        toast.error(item?.message || "Please try again !!", {
          duration: 4000,
          position: "top-right",
        });
      }
      setDisabled(false);
    });
    toast.dismiss("");
  };

  const onSuccessUploadDocumentType = (data) => {
    setFormInputs((formInputs) => ({
      ...formInputs,
      [data.fieldName]: data.attachmentId,
    }));
  };

  const handleViewFile = (fileAttachmentId) => {
    setFileViewData(fileAttachmentId);
    setShowFileViewModal(true);
  };
  const handleViewFileHide = () => {
    setShowFileViewModal(false);
  };
  /*  web plate */

  const handleInputChange = (field, value) => {
    setFormInputs((prev) => {
      const updated = { ...prev, [field]: value };
      const { thickNess, webPlateX, webPlateY } = updated;

      // ✅ if OTHERS → use current formInputs.materialGroup (already typed value in prev)
      // ✅ if normal dropdown → use webplate.materialGroup
      const materialGroupValue =
        webplate?.materialGroupCode === "OTHERS"
          ? prev?.materialGroup // typed value stored in formInputs
          : webplate?.materialGroup; // dropdown selected value

      if (materialGroupValue && materialGroupValue !== "OTHERS") {
        // ✅ block "OTHERS" string
        let desc = materialGroupValue;

        if (thickNess) desc += ` ${thickNess}MM`;

        if (webPlateX && webPlateY) {
          desc += ` (${webPlateX}-${webPlateY})`;
        } else if (webPlateX) {
          desc += ` (${webPlateX})`;
        } else if (webPlateY) {
          desc += ` (${webPlateY})`;
        }

        updated.materialDescription = desc;
      }

      return updated;
    });
  };
  const [getBuildingType, setBuildingType] = useState();
 
  // eslint-disable-next-line
  const buildingTypeArray =
    getBuildingType?.buildingType
      ?.filter((building) => building?.code)
      ?.map((building) => building.code)
      ?.sort((a, b) => {
        const order = { MG: 1, CS: 2, MS: 3 };
        return (order[a] || 999) - (order[b] || 999);
      }) || [];

  useEffect(() => {
    if (getDropdownData) {
      const field = getDropdownData.textField;

      if (field === "materialGroup") {
        setWebPlate({
          materialGroup: getDropdownData?.name,
          materialGroupCode: getDropdownData?.code,
          materialGroupDesc: getDropdownData?.description,
        });
      } else if (
        field === "materialCategory" ||
        field === "materialSubCategory"
      ) {
        setWebPlate((prev) => ({
          ...prev,
          [field]: getDropdownData.name,
          [`${field}Code`]: getDropdownData.code,
          [`${field}Desc`]: getDropdownData.description,
        }));
      } else if (field === "buildingType") {
        const selectedArray = getDropdownData?.selected || [];

        setBuildingType({ buildingType: selectedArray });

        // ✅ Store as array of code strings only — NOT full objects
        setFormInputs((prev) => ({
          ...prev,
          buildingType: selectedArray.map((item) =>
            typeof item === "object" ? item?.code : item,
          ),
        }));
      }
    }
  }, [getDropdownData]);

  useEffect(() => {
    const materialGroupValue =
      webplate?.materialGroupCode === "OTHERS"
        ? formInputs?.materialGroup // ✅ use typed value when OTHERS
        : webplate?.materialGroup; // ✅ use dropdown value normally

    if (!materialGroupValue) return;

    setFormInputs((prev) => {
      const { thickNess, webPlateX, webPlateY } = prev;

      let desc = materialGroupValue;

      if (thickNess) desc += ` ${thickNess}MM`;

      if (webPlateX && webPlateY) {
        desc += ` (${webPlateX}-${webPlateY})`;
      } else if (webPlateX) {
        desc += ` (${webPlateX})`;
      } else if (webPlateY) {
        desc += ` (${webPlateY})`;
      }

      return { ...prev, materialDescription: desc };
    });
  }, [webplate, formInputs?.materialGroup]); // ✅ also watch formInputs.materialGroup

  //validation
  const handleCheckValidation = async ({ target: { name, value } }) => {
    if (!value) return false;

    let obj = {};
    let queryName = "";

    // Choose the correct query based on field name
    if (name === "materialCode") {
      queryName = "Check_Material_Duplication";
      obj = { queryName, materialCode: value };
    } else {
      return false;
    }

    try {
      const item = await ItemService.generateCustomerQueryHb(obj);
      let errorMsg = "";

      if (
        item?.status === 200 &&
        item?.data?.length > 0 &&
        item.data[0].isItDuplicate === "true"
      ) {
        errorMsg = `This ${
          name === "materialCode" ? "Material" : "Material"
        } Code already exists.`;
      }

      // Update validation state
      setValidation((prev) => ({
        ...prev,
        [name]: errorMsg,
      }));

      return errorMsg ? true : false;
    } catch (err) {
      console.error("Error during validation:", err);
      setValidation((prev) => ({
        ...prev,
        [name]: "Unable to validate. Please try again.",
      }));
      return true;
    }
  };
  //getDropdownData textField
  // useEffect(() => {
  //   if (getDropdownData) {
  //     const field = getDropdownData.textField;

  //     if (field === "materialGroup") {
  //       setWebPlate({
  //         materialGroup: getDropdownData?.name,
  //         materialGroupCode: getDropdownData?.code,
  //         materialGroupDesc: getDropdownData?.description,
  //       });
  //     } else if (
  //       field === "materialCategory" ||
  //       field === "materialSubCategory"
  //     ) {
  //       setWebPlate((prev) => ({
  //         ...prev,
  //         [field]: getDropdownData.name,
  //         [`${field}Code`]: getDropdownData.code,
  //         [`${field}Desc`]: getDropdownData.description,
  //       }));
  //     } else if (field === "buildingType") {
  //       setBuildingType((prev) => ({
  //         ...prev,
  //         [field]: getDropdownData.name,
  //         [`${field}Code`]: getDropdownData.code,
  //         [`${field}Desc`]: getDropdownData.description,
  //       }));
  //     }
  //   }
  // }, [getDropdownData]);

  useEffect(() => {
    if (getDropdownData) {
      const field = getDropdownData.textField;

      if (field === "materialGroup") {
        setWebPlate({
          materialGroup: getDropdownData?.name,
          materialGroupCode: getDropdownData?.code,
          materialGroupDesc: getDropdownData?.description,
        });
      } else if (
        field === "materialCategory" ||
        field === "materialSubCategory"
      ) {
        setWebPlate((prev) => ({
          ...prev,
          [field]: getDropdownData.name,
          [`${field}Code`]: getDropdownData.code,
          [`${field}Desc`]: getDropdownData.description,
        }));
      } else if (field === "buildingType") {
        // ✅ selected is the array of selected items from MultiselectField
        setBuildingType({
          buildingType: getDropdownData?.selected || [],
        });

        // ✅ also update formInputs
        setFormInputs((prev) => ({
          ...prev,
          buildingType: getDropdownData?.selected || [],
        }));
      }
    }
  }, [getDropdownData]);

  // Handler for "Others" input fields
  const handleOthersInputChange = (field, value) => {
    const upperValue = value.toUpperCase();
    const codeValue = upperValue.slice(0, 3);

    // ✅ Update formInputs with typed value
    setFormInputs((prev) => ({
      ...prev,
      [field]: upperValue,
      [`${field}Code`]: codeValue,
      [`${field}Desc`]: upperValue,
    }));

    // ✅ Keep webplate code as "OTHERS" so InputField stays visible
    setWebPlate((prev) => ({
      ...prev,
      [`${field}Code`]: "OTHERS",
    }));
  };

  const handleResetToCombobox = (field) => {
    setWebPlate((prev) => ({
      ...prev,
      [field]: "",
      [`${field}Code`]: "",
      [`${field}Desc`]: "",
    }));
    setFormInputs((prev) => ({
      ...prev,
      [field]: "",
      [`${field}Code`]: "",
      [`${field}Desc`]: "",
    }));
  };

  return (
    <>
      <Modal
        {...props}
        aria-labelledby="contained-modal-title-vcenter"
        keyboard={false}
        size="xl"
        ref={ref}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter">
            {props?.show === "CREATE"
              ? "Create Material"
              : props?.show === "DETAILS"
                ? "Material Detail"
                : props?.show === "EDIT"
                  ? "Edit Material"
                  : ""}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="">
          {loading ? (
            <div
              className="d-flex justify-content-center align-items-center"
              style={{ minHeight: "200px" }}
            >
              <div className="spinner-border text-primary" role="status">
                <span className="visually-hidden">Loading...</span>
              </div>
            </div>
          ) : (
            <>
              {/* accordin1 */}
              <div
                xs={12}
                md={6}
                lg={6}
                className="commLeftRightPadding d-flex align-items-end mb-4"
              >
                {props?.show !== "DETAILS" && (
                  <Col xs={12} md={4} lg={4} className="commLeftRightPadding">
                    <FileUploadComponentForHB
                      id="materialImage"
                      name="materialImage"
                      label="Material Image"
                      allowedTypes={["image/png", "image/jpeg"]} // ✅ only images
                      multiple={false} // ✅ only single file selection
                      required={true}
                      onSuccessUpload={onSuccessUploadDocumentType}
                      value={formInputs?.materialImage || ""}
                    />
                  </Col>
                )}
                <Col
                  xs={12}
                  md={4}
                  lg={4}
                  className="commLeftRightPadding d-flex justify-content-center align-items-center"
                >
                  <div
                    style={{ width: "100%" }}
                    className="d-flex justify-content-center align-items-center"
                  >
                    {/* {formInputs?.materialImage && (
                      <img
                        src="assets/img/newIcons/attached-file.png"
                        className="mt-1 attachmentIcon"
                        alt="attachments"
                        onClick={() =>
                          handleViewFile(formInputs?.materialImage)
                        }
                      />
                    )} */}
                    <ShowUploadImage fileid={formInputs?.materialImage} />
                  </div>
                </Col>
              </div>
              <div className="accordion mb-4" id="accordionExample">
                <div className="accordion-item">
                  <h2 className="accordion-header">
                    <Row className="accordion-button">
                      <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                        <i
                          className={`bi ${
                            isCardVisible1
                              ? "bi-chevron-down"
                              : "bi-chevron-right"
                          }`}
                          onClick={toggleCardVisibility1}
                        ></i>
                      </Col>
                      <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                        <span className="iconLogo">BI</span>
                      </Col>
                      <Col xs={8} md={9} lg={9}>
                        <span className="headerTitle">Basic Information</span>
                        <span className="subHeaderTitle">
                          Basic Infromation
                        </span>
                      </Col>
                    </Row>
                  </h2>

                  <div
                    className={`accordion-collapse collapse show ${
                      isCardVisible1 ? "visible" : ""
                    }`}
                  >
                    <div className="accordion-body">
                      <Row className="pt-2 pb-4 d-flex align-items-center">
                        <Col
                          xs={12}
                          md={6}
                          lg={6}
                          className="commLeftRightPadding"
                        >
                          <InputField
                            placeholder=""
                            className="inputBox"
                            // label="Material Code"
                            label={
                              <>
                                <i className="bi bi-upc-scan labelIcon"></i>
                                Material Code
                              </>
                            }
                            id="materialCode"
                            name="materialCode"
                            type="text"
                            value={formInputs?.materialCode || ""}
                            onChange={onInputChange}
                            onBlur={handleCheckValidation}
                            disabled={
                              props?.show === "EDIT" ||
                              props?.show === "DETAILS"
                            }
                            error={validation?.materialCode}
                          />
                        </Col>
                        {/* 
                        <Col
                          xs={12}
                          md={6}
                          lg={6}
                          className="commTopButtonRightLeftPadding"
                        >
                          <ComboboxField
                            className="inputBox"
                            label="Material Group"
                            placeholder=""
                            data={materialGroups}
                            name="materialGroup"
                            code="materialGroupCode"
                            description="materialGroupDesc"
                            setValue={
                              webplate?.materialGroup ||
                              formInputs?.materialGroup ||
                              ""
                            }
                            getvalue={setDropdownData}
                            disabled={materialMode}
                          />
                        </Col> */}

                        <Col
                          xs={12}
                          md={6}
                          lg={6}
                          className="commTopButtonRightLeftPadding"
                        >
                          {webplate?.materialGroupCode === "OTHERS" ? (
                            <>
                              {!materialMode && (
                                <span
                                  style={{
                                    cursor: "pointer",
                                    color: "blue",
                                    fontSize: "12px",
                                  }}
                                  onClick={() =>
                                    handleResetToCombobox("materialGroup")
                                  }
                                >
                                  ↩ Reset to Dropdown
                                </span>
                              )}
                              <InputField
                                // label="Material Group *"
                                 label={
                              <>
                                <i className="bi bi-collection labelIcon"></i>
                                Material Group
                              </>
                            }
                                id="materialGroup"
                                className="inputBox"
                                name="materialGroup"
                                type="text"
                                value={formInputs?.materialGroup || ""}
                                onChange={(e) =>
                                  handleOthersInputChange(
                                    "materialGroup",
                                    e.target.value,
                                  )
                                }
                                disabled={materialMode}
                                error={validation?.materialGroup}
                              />
                            </>
                          ) : (
                            <ComboboxField
                              className="inputBox"
                              // label="Material Group"
                              label={
                              <>
                                <i className="bi bi-tags labelIcon"></i>
                                Material Category
                              </>
                            }
                              placeholder=""
                              data={materialGroups}
                              name="materialGroup"
                              code="materialGroupCode"
                              description="materialGroupDesc"
                              setValue={
                                webplate?.materialGroup ||
                                formInputs?.materialGroup ||
                                ""
                              }
                              getvalue={setDropdownData}
                              disabled={materialMode}
                            />
                          )}
                        </Col>

                        <Col
                          xs={12}
                          md={6}
                          lg={6}
                          className="commTopButtonRightLeftPadding"
                        >
                          {webplate?.materialCategoryCode === "OTHERS" ? (
                            <>
                              {!materialMode && (
                                <span
                                  style={{
                                    cursor: "pointer",
                                    color: "blue",
                                    fontSize: "12px",
                                  }}
                                  onClick={() =>
                                    handleResetToCombobox("materialCategory")
                                  }
                                >
                                  ↩ Reset to Dropdown
                                </span>
                              )}
                              <InputField
                                // label="Material Category *"
                                label={
                              <>
                                <i className="bi bi-diagram-3 labelIcon"></i>
                                Material Sub Category *
                              </>
                            }
                                id="materialCategory"
                                className="inputBox"
                                name="materialCategory"
                                type="text"
                                value={formInputs?.materialCategory || ""}
                                onChange={(e) =>
                                  handleOthersInputChange(
                                    "materialCategory",
                                    e.target.value,
                                  )
                                }
                                disabled={materialMode}
                                error={validation?.materialCategory}
                              />
                            </>
                          ) : (
                            <ComboboxField
                              className="inputBox"
                              // label="Material Category"
                              label={
                              <>
                                <i className="bi bi-diagram-3 labelIcon"></i>
                                Material Sub Category
                              </>
                            }
                              placeholder=""
                              data={materialGroups}
                              name="materialCategory"
                              code="materialCategoryCode"
                              description="materialCategoryDesc"
                              setValue={
                                webplate?.materialCategory ||
                                formInputs?.materialCategory ||
                                ""
                              }
                              getvalue={setDropdownData}
                              disabled={materialMode}
                            />
                          )}
                        </Col>
                        {/* Material Sub Category */}
                        <Col
                          xs={12}
                          md={6}
                          lg={6}
                          className="commTopButtonRightLeftPadding"
                        >
                          {webplate?.materialSubCategoryCode === "OTHERS" ? (
                            <>
                              {!materialMode && (
                                <span
                                  style={{
                                    cursor: "pointer",
                                    color: "blue",
                                    fontSize: "12px",
                                  }}
                                  onClick={() =>
                                    handleResetToCombobox("materialSubCategory")
                                  }
                                >
                                  ↩ Reset to Dropdown
                                </span>
                              )}
                              <InputField
                                // label="Material Sub Category *"
                                 label={
                              <>
                                <i className="bi bi-diagram-3 labelIcon"></i>
                                Material Sub Category *
                              </>
                            }
                                id="materialSubCategory"
                                className="inputBox"
                                name="materialSubCategory"
                                type="text"
                                value={formInputs?.materialSubCategory || ""}
                                onChange={(e) =>
                                  handleOthersInputChange(
                                    "materialSubCategory",
                                    e.target.value,
                                  )
                                }
                                disabled={materialMode}
                                error={validation?.materialSubCategory}
                              />
                            </>
                          ) : (
                            <ComboboxField
                              className="inputBox"
                              // label="Material Sub Category"
                               label={
                              <>
                                <i className="bi bi-diagram-3 labelIcon"></i>
                                Material Sub Category*
                              </>
                            }
                              placeholder=""
                              data={materialGroups}
                              name="materialSubCategory"
                              code="materialSubCategoryCode"
                              description="materialSubCategoryDesc"
                              setValue={
                                webplate?.materialSubCategory ||
                                formInputs?.materialSubCategory ||
                                ""
                              }
                              getvalue={setDropdownData}
                              disabled={materialMode}
                            />
                          )}
                        </Col>

                        {/* <Col
                          xs={12}
                          md={6}
                          lg={6}
                          className="commTopButtonRightLeftPadding"
                        >
                          <ComboboxField
                            className="inputBox"
                            label="Material Category"
                            placeholder=""
                            data={materialGroups}
                            name="materialCategory"
                            code="materialCategoryCode"
                            description="materialCategoryDesc"
                            setValue={
                              webplate?.materialCategory ||
                              formInputs?.materialCategory ||
                              ""
                            }
                            getvalue={setDropdownData}
                            disabled={materialMode}
                          />

                        </Col>
                        <Col
                          xs={12}
                          md={6}
                          lg={6}
                          className="commTopButtonRightLeftPadding"
                        >
                          <ComboboxField
                            className="inputBox"
                            label="Material Sub Category"
                            placeholder=""
                            data={materialGroups}
                            name="materialSubCategory"
                            code="materialSubCategoryCode"
                            description="materialSubCategoryDesc"
                            setValue={
                              webplate?.materialSubCategory ||
                              formInputs?.materialSubCategory ||
                              ""
                            }
                            getvalue={setDropdownData}
                            disabled={materialMode}
                          />
                        </Col> */}
                        {/* Thickness Input */}
                        <Col
                          xs={12}
                          md={6}
                          lg={6}
                          className="commLeftRightPadding"
                        >
                          <InputField
                            // label="Thick Ness in MM"
                             label={
                              <>
                                <i className="bi bi-rulers labelIcon"></i>
                                Thickness in MM
                              </>
                            }
                            id="thickNess"
                            className="inputBox"
                            name="thickNess"
                            type="number"
                            value={formInputs?.thickNess || ""}
                            onChange={(e) =>
                              handleInputChange("thickNess", e.target.value)
                            }
                            disabled={materialMode}
                            error={validation?.thickNess}
                          />
                        </Col>

                        {/* depth */}
                        {/* <Col
                          xs={12}
                          md={6}
                          lg={6}
                          className="commLeftRightPadding"
                        >
                          <InputField
                            label="Depth"
                            className="inputBox"
                            id="depth"
                            name="depth"
                            type="number"
                            value={formInputs?.depth || ""}
                            onChange={(e) =>
                              handleInputChange("depth", e.target.value)
                            }
                            disabled={materialMode}
                            error={validation?.webPlateY}
                          />
                        </Col> */}

                        {/*width  */}
                        {/* <Col
                          xs={12}
                          md={6}
                          lg={6}
                          className="commLeftRightPadding"
                        >
                          <InputField
                            label="Width"
                            className="inputBox"
                            id="widht"
                            name="widht"
                            type="number"
                            value={formInputs?.depth || ""}
                            onChange={(e) =>
                              handleInputChange("widht", e.target.value)
                            }
                            disabled={materialMode}
                            error={validation?.webPlateY}
                          />
                        </Col> */}

                        {/*  web plate Data*/}
                        {/*   {(webplate?.materialGroup ||
                          formInputs?.materialGroup) !== "HB" && (
                          <>
                            <Col
                              xs={12}
                              md={6}
                              lg={6}
                              className="commLeftRightPadding"
                            >
                              <InputField
                                label="Web Plate - X"
                                className="inputBox"
                                id="webPlateX"
                                name="webPlateX"
                                type="number"
                                value={formInputs?.webPlateX || ""}
                                onChange={(e) =>
                                  handleInputChange("webPlateX", e.target.value)
                                }
                                disabled={materialMode}
                                error={validation?.webPlateX}
                              />
                            </Col>

                            <Col
                              xs={12}
                              md={6}
                              lg={6}
                              className="commLeftRightPadding"
                            >
                              <InputField
                                label="Web Plate - Y"
                                className="inputBox"
                                id="webPlateY"
                                name="webPlateY"
                                type="number"
                                value={formInputs?.webPlateY || ""}
                                onChange={(e) =>
                                  handleInputChange("webPlateY", e.target.value)
                                }
                                disabled={materialMode}
                                error={validation?.webPlateY}
                              />
                            </Col>
                          </>
                        )} */}

                        <Col
                          xs={12}
                          md={6}
                          lg={6}
                          className="commLeftRightPadding"
                        >
                          <InputField
                            placeholder=""
                            className="inputBox"
                            // label="Material Description"
                             label={
                              <>
                                <i className="bi bi-card-text labelIcon"></i>
                                Material Description
                              </>
                            }
                            id="materialDescription"
                            name="materialDescription"
                            type="text"
                            value={formInputs?.materialDescription || ""}
                            onChange={onInputChange}
                            disabled={
                              ["HB", "APSHSX"].includes(
                                webplate?.materialGroup ||
                                  formInputs?.materialGroup,
                              )
                                ? materialMode
                                : true
                            }
                            error={validation?.materialDescription}
                          />
                        </Col>

                        <Col
                          xs={12}
                          md={6}
                          lg={6}
                          className="commTopButtonRightLeftPadding"
                        >
                          <MultiselectField
                            // label="Building Type"
                            label={
                              <>
                                <i className="bi bi-building labelIcon"></i>
                                Building Type
                              </>
                            }
                            placeholder="Please select the building Type"
                            data={buildingTypes}
                            id="buildingType"
                            iconClassName="dropdownIcon"
                            name="buildingType"
                            getvalue={setDropdownData}
                            setValue={formInputs?.buildingType}
                            className="dropdownOption"
                          />
                        </Col>

                        {/* <Col
                          xs={12}
                          md={6}
                          lg={6}
                          className="commLeftRightPadding"
                        >
                          <InputField
                            placeholder=""
                            className="inputBox"
                            label="Material Group"
                            id="materialGroup"
                            name="materialGroup"
                            type="text"
                            value={formInputs?.materialGroup || ""}
                            onChange={onInputChange}
                            disabled={materialMode}
                            error={validation?.materialGroup}
                          />
                        </Col> */}
                        {/*   <Col
                          xs={12}
                          md={6}
                          lg={6}
                          className="commLeftRightPadding"
                        >
                          <InputField
                            placeholder=""
                            className="inputBox"
                            label="AVG"
                            id="average"
                            name="average"
                            type="text"
                            value={formInputs?.average || ""}
                            onChange={onInputChange}
                            disabled={materialMode}
                          />
                        </Col> */}

                        {/* <Col xs={12} md={6} lg={6} className="commLeftRightPadding">
                      <InputField
                        placeholder=""
                        className="inputBox"
                        label="Quntity"
                        id="quntity"
                        name="quntity"
                        type="number"
                        value={formInputs.quntity || ""}
                        onChange={onInputChange}
                      />
                    </Col>
                    <Col xs={12} md={6} lg={6} className="commLeftRightPadding">
                      <InputField
                        placeholder=""
                        className="inputBox"
                        label="Piece Measure"
                        id="pieceMeasure"
                        name="pieceMeasure"
                        type="number"
                        value={formInputs.pieceMeasure || ""}
                        onChange={onInputChange}
                      />
                    </Col> */}

                        <Col
                          xs={12}
                          md={6}
                          lg={6}
                          className="commLeftRightPadding"
                        >
                          <InputField
                            placeholder=""
                            className="inputBox"
                            // label="Unit"
                            label={
                              <>
                                <i className="bi bi-box labelIcon"></i>
                                Unit
                              </>
                            }
                            id="unit"
                            name="unit"
                            type="text"
                            value={formInputs?.unit || ""}
                            onChange={onInputChange}
                            disabled={materialMode}
                            error={validation?.unit}
                          />
                        </Col>
                        <Col
                          xs={12}
                          md={6}
                          lg={6}
                          className="commLeftRightPadding"
                        >
                          <InputField
                            placeholder=""
                            className="inputBox"
                            // label="Unit Weight"
                             label={
                              <>
                                <i className="bi bi-speedometer2 labelIcon"></i>
                                Unit Weight
                              </>
                            }
                            id="unitWeight"
                            name="unitWeight"
                            type="text"
                            value={formInputs?.unitWeight || ""}
                            onChange={onInputChange}
                            disabled={materialMode}
                            error={validation?.unitWeight}
                          />
                        </Col>
                        <Col
                          xs={12}
                          md={6}
                          lg={6}
                          className="commLeftRightPadding"
                        >
                          <InputField
                            placeholder=""
                            className="inputBox"
                            // label="Unit Price
                            label={
                              <>
                                <i className="bi bi-currency-rupee labelIcon"></i>
                                Unit Price
                              </>
                            }
                            id="unitPrice"
                            name="unitPrice"
                            type="text"
                            value={formInputs?.unitPrice || ""}
                            onChange={onInputChange}
                            disabled={materialMode}
                            error={validation?.unitPrice}
                          />
                        </Col>
                        {/* <Col
                          xs={12}
                          md={6}
                          lg={6}
                          className="commLeftRightPadding"
                        >
                          <InputField
                            placeholder=""
                            className="inputBox"
                            label="Unit weight Modifier"
                            id="unitWeightModifier"
                            name="unitWeightModifier"
                            type="text"
                            value={formInputs?.unitWeightModifier || ""}
                            onChange={onInputChange}
                            disabled={materialMode}
                            error={validation?.unitWeightModifier}
                          />
                        </Col> */}
                        {/* <Col
                          xs={12}
                          md={6}
                          lg={6}
                          className="commLeftRightPadding"
                        >
                          <InputField
                            placeholder=""
                            className="inputBox"
                            label="Unit Price Modifier"
                            id="unitPriceModifier"
                            name="unitPriceModifier"
                            type="text"
                            value={formInputs?.unitPriceModifier || ""}
                            onChange={onInputChange}
                            disabled={materialMode}
                            error={validation?.unitPriceModifier}
                          />
                        </Col> */}
                        {/* <Col
                          xs={12}
                          md={6}
                          lg={6}
                          className="commLeftRightPadding"
                        >
                          <InputField
                            placeholder=""
                            className="inputBox"
                            label="Surface/Paint Area"
                            id="surfacePaintArea"
                            name="surfacePaintArea"
                            type="number"
                            value={formInputs?.surfacePaintArea || ""}
                            onChange={onInputChange}
                            disabled={materialMode}
                            // error={validation?.surfacePaintArea}
                          />
                        </Col> */}
                        <Col
                          xs={12}
                          md={6}
                          lg={6}
                          className="commLeftRightPadding"
                        >
                          <TextAreaField
                            placeholder=""
                            className="inputBox"
                            // label="Remarks"
                            label={
                              <>
                                <i className="bi bi-chat-left-text labelIcon"></i>
                                Remarks
                              </>
                            }
                            id="remarks"
                            name="remarks"
                            value={formInputs?.remarks || ""}
                            onChange={onInputChange}
                            disabled={materialMode}
                            error={validation?.remarks}
                          />
                        </Col>
                        <Col
                          xs={12}
                          md={6}
                          lg={6}
                          className="commLeftRightPadding"
                        >
                          <FileUploadComponentForHB
                            id="materialAttachments"
                            name="materialAttachments"
                            // label="Material Attachments"
                             label={
                              <>
                                <i className="bi bi-paperclip labelIcon"></i>
                                Material Attachments
                              </>
                            }
                            allowedTypes={["image/png", "image/jpeg", "application/pdf", ".dwg"]}
                            multiple={true} // Change to false for single file selection
                            onSuccessUpload={onSuccessUploadDocumentType}
                            value={formInputs?.materialAttachments || ""}
                            error={validation?.materialAttachments}
                          />
                        </Col>
                        <Col
                          xs={12}
                          md={6}
                          lg={6}
                          className="commLeftRightPadding"
                        >
                          {formInputs?.materialAttachments && (
                            // <ShowUploadImage  fileid= {formInputs?.materialAttachments}/>
                            // <ShowUploadImage fileid={formInputs?.materialAttachment || formInputs?.materialAttachments} />

                            <img
                              src="assets/img/newIcons/attached-file.png"
                              className="mt-1 attachmentIcon"
                              alt="attachments"
                              onClick={() =>
                                handleViewFile(formInputs?.materialAttachments)
                              }
                            />
                          )}
                        </Col>

                        {/* <Col xs={12} md={6} lg={6} className="commLeftRightPadding">
                      <InputField
                        placeholder=""
                        className="inputBox"
                        label="Weight Pice"
                        id="weightPice"
                        name="weightPice"
                        type="text"
                        value={formInputs.weightPice || ""}
                        // onChange={onInputChange}
                        disabled={true}
                      />
                    </Col>
                    <Col xs={12} md={6} lg={6} className="commLeftRightPadding">
                      <InputField
                        placeholder=""
                        className="inputBox"
                        label="Weight Total"
                        id="weightTotal"
                        name="weightTotal"
                        type="text"
                        value={formInputs.weightTotal || ""}
                        // onChange={onInputChange}
                        disabled={true}
                      />
                    </Col>
                    <Col xs={12} md={6} lg={6} className="commLeftRightPadding">
                      <InputField
                        placeholder=""
                        className="inputBox"
                        label="Book Price"
                        id="bookPrice"
                        name="bookPrice"
                        type="text"
                        value={formInputs.bookPrice || ""}
                        // onChange={onInputChange}
                        disabled={true}
                      />
                    </Col>
                    <Col xs={12} md={6} lg={6} className="commLeftRightPadding">
                      <InputField
                        placeholder=""
                        className="inputBox"
                        label="Book Total Price"
                        id="bookTotalPrice"
                        name="bookTotalPrice"
                        type="text"
                        value={formInputs.bookTotalPrice || ""}
                        // onChange={onInputChange}
                        disabled={true}
                      />
                    </Col> */}
                        <Col xs={12} md={12} lg={12}></Col>
                      </Row>
                    </div>
                  </div>
                </div>
              </div>
              {props.show !== "DETAILS" && (
                <div className="space-y-4">
                  <Row className="justify-end">
                    <Col xs={6} md={3} lg={3} className="commLeftRightPadding">
                      <button
                        type="button"
                        onClick={() => props.onHide()}
                        className="btn btn-danger mt-4 w-full justify-center rounded-md"
                      >
                        Cancel
                      </button>
                    </Col>
                    {props.show === "CREATE" && (
                      <Col
                        xs={6}
                        md={3}
                        lg={3}
                        className="commLeftRightPadding"
                      >
                        <button
                          onClick={handleSubmit}
                          disabled={disabled}
                          className="btn btn-primary mt-4 w-full justify-center rounded-md"
                        >
                          Save
                        </button>
                      </Col>
                    )}
                    {props.show === "EDIT" && (
                      <Col
                        xs={6}
                        md={3}
                        lg={3}
                        className="commLeftRightPadding"
                      >
                        <button
                          onClick={handleUpdate}
                          disabled={disabled}
                          className="btn btn-primary mt-4 w-full justify-center rounded-md"
                        >
                          Update
                        </button>
                      </Col>
                    )}
                    <Col
                      xs={12}
                      md={12}
                      lg={12}
                      className="commLeftRightPadding"
                    >
                      {/* <p className="errorMsg"> {errorMsg} </p> */}
                    </Col>
                  </Row>
                </div>
              )}
            </>
          )}
        </Modal.Body>
      </Modal>

      <FileViewerModalForHB
        show={getShowFileViewModal}
        onHide={handleViewFileHide}
        fileid={getFileViewData}
        onDeleteSuccess={handleAttachmentDeleted}

      />
      <FileViewerModalForHB
        show={getShowFailureModal}
        onHide={() => hideFailureModal()}
        failuremodaldata={failureModalData}
        requiredfields={getErrorFields}
        onDeleteSuccess={handleAttachmentDeleted}
      />
    </>
  );
});

export default MaterialHBModal;
